import React from 'react';
import _ from 'lodash';
import Helmet from 'react-helmet';

import _masterSlideLoader from '../utilities/masterSlideLoader';
import { HEADER_CONSTANTS, USER_STATUS } from '../utilities/constants';
import { FormList } from '../components/CommonFormComponents';
import {
  PreviewFormText,
  PreviewFormImage,
  PreviewFormTel,
} from '../components/PreviewForm';
import { roleIdToJapaneseRoleName } from '../utilities/roleUtility';
import { CompanyBranchService } from '../services/CompanyBranches'; // 協力会社API
import PrimeContractorButton from '../components/button/PrimeContractorButton';
import { MasterPageHeader } from '../components/PageHeader';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { HEAD_OFFICE_OPTION } from '../components/PartnerCompanyBranchDropdown';

/**
 * 協力会社ユーザー詳細
 * 画面遷移
 *  1.  協力会社一覧>>ユーザー確認>>職業行の確認ボタン
 */
export class PartnerUserPreview extends React.Component {
  constructor(props) {
    super(props);

    // タイトル名
    this.TITLE_NAME = '協力会社ユーザー詳細';

    // パラメータ分解
    const param = this.props.view.state.id.split('.');

    this.state = {
      partnerCompanyId: param[0], // 協力会社ID
      companyBranchId: param[1], // 支店ID
      partnerUserId: param[2], // 協力会社ユーザーID
      company: {
        name: '',
      }, // 協力会社情報
      image: '', // プロフィール画像
      formValues: {
        image: '', // プロフィール画像
        // 有りえない数字や空文字ではなくundefinedで初期化
        user_role_code: undefined, // ユーザー種別
        company_name: '', // 所属会社
        name_sei: '', // 姓
        name_mei: '', // 名
        kana_sei: '', // せい
        kana_mei: '', // めい
        login_id: '', // ログインID
        email: '', // メールアドレス
        tel: '', // 電話番号
        block_flag: undefined, // ステータス
      },
    };

    this.partnerCompanyJoiningFlag = SessionStorageService.getPartnerCompanyJoiningFlag();
  }

  componentDidMount() {
    const { companyBranchId, partnerCompanyId, partnerUserId } = this.state;
    const param = {
      company_branch_id: companyBranchId,
    };

    // 協力会社情報取得
    CompanyBranchService.show(partnerCompanyId, param).then(
      ({ result, data }) => {
        if (result) {
          // 協力会社情報
          const partnerCompany = data.entities;
          // フォームに値セット
          CompanyBranchService.companyPartnerUser(partnerUserId, {
            company_id: partnerCompanyId,
          }).then(({ result, data }) => {
            if (result) {
              const { user } = data.entities;
              this.initForm(partnerCompany, user);
            }
          });
        }
      }
    );
  }

  /**
   * フォーム生成
   *
   * @param {object} partnerCompany 協力会社情報
   * @param {object} partnerUser 協力会社ユーザー情報
   * @memberof PartnerUserPreview
   */
  initForm = (partnerCompany, partnerUser) => {
    let formValues = this.state.formValues;
    formValues.company_name = partnerCompany.company.name;

    formValues.partner_company_branch_name = _.get(
      partnerUser,
      'partner_company_branch.name'
    );

    // ログインID
    formValues.login_id = partnerUser.login_id;

    // ユーザーロール
    formValues.user_role_code = partnerUser.user_role.code;

    _.each(partnerUser, (user, index) => {
      if (_.has(this.state.formValues, index)) {
        formValues[index] = user ? user : '';
      }
    });

    this.setState({
      company: partnerCompany.company,
      image: partnerUser.image_url,
      formValues,
    });
  };

  render() {
    const id = `${this.state.partnerCompanyId}.${this.state.companyBranchId}.${
      this.state.partnerUserId
    }`;

    return (
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} - {this.TITLE_NAME}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={`${this.state.company.name} ${this.TITLE_NAME}`}
            onClose={() =>
              _masterSlideLoader.show('PartnerUsers', { state: { id } })
            }
          />
          <div className='contruction-slide-view__body contruction-slide-view__body--height-fix'>
            <div className='contruction-detail-view'>
              <div className='contruction-detail-view__body contruction-detail-view__body--fixed'>
                <div className='contruction-detail-view__header'>
                  <button
                    className='btn-text--sm'
                    onClick={() =>
                      _masterSlideLoader.show('PartnerUsers', {
                        state: {
                          id: `${this.state.partnerCompanyId}.${
                            this.state.companyBranchId
                          }`,
                        },
                      })
                    }
                  >
                    <i className='i-back--blue i-2x vertical-middle' />
                    ユーザー一覧
                  </button>
                </div>
                <div className='contruction-detail-view__menu'>
                  <span className='construction-detail-view__button'>
                    {/* 編集ボタン(協力会社ユーザの編集は、元請固有の職長のみ可能) */}
                    <PrimeContractorButton
                      buttonClass='btn'
                      label='編集'
                      user={{
                        roleId: this.state.formValues.user_role_code,
                        company: this.state.company,
                      }}
                      onClick={() =>
                        // 編集へ遷移
                        _masterSlideLoader.show('PartnerUserEdit', {
                          state: { id },
                        })
                      }
                    />
                  </span>
                </div>
                <div className='contruction-detail-view__bar' />
                <PreviewForm
                  values={this.state.formValues}
                  image={this.state.image}
                  partnerCompanyJoiningFlag={this.partnerCompanyJoiningFlag}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const PreviewForm = ({ values, image, partnerCompanyJoiningFlag }) => {
  const getRoleName = userRoleCode => {
    return userRoleCode ? roleIdToJapaneseRoleName(userRoleCode) : false;
  };

  const getPartnerCompanyBranchName = () => {
    if (partnerCompanyJoiningFlag) {
      return (
        <PreviewFormText
          label='支店'
          values={[
            _.get(
              values,
              'partner_company_branch_name',
              HEAD_OFFICE_OPTION.name
            ),
          ]}
        />
      );
    }
  };

  return (
    <div className='contruction-detail-view__main contruction-detail-view__main--fixed contruction-detail-view__main--fix'>
      <FormList>
        {values.block_flag === USER_STATUS.stop.id && (
          <PreviewFormText
            label='ステータス'
            values={[USER_STATUS.stop.name]}
          />
        )}
        <PreviewFormText
          label='ユーザー種別'
          values={[getRoleName(values.user_role_code)]}
        />
        <PreviewFormText label='所属会社' values={[values.company_name]} />
        {getPartnerCompanyBranchName()}
        <PreviewFormText label='姓' values={[values.name_sei]} />
        <PreviewFormText label='名' values={[values.name_mei]} />
        <PreviewFormText label='せい' values={[values.kana_sei]} />
        <PreviewFormText label='めい' values={[values.kana_mei]} />
        <PreviewFormTel label='電話番号' values={[values.tel]} />
        <PreviewFormText label='ユーザーID' values={[values.login_id]} />
        <PreviewFormText label='メールアドレス' values={[values.email]} />
        <PreviewFormImage label='アイコン画像' imgUrl={image} />
      </FormList>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/PartnerUserPreview.jsx